import BaseEnumType from "../../common/base-enum-type";

const ScoringMode = Object.freeze({
    BestOfSeries: { ...new BaseEnumType("1", "Best of series"), value: 1 },
    OnePointPerMatch: {
        ...new BaseEnumType("2", "One point per match"),
        value: 2
    }
});

export default ScoringMode;
